<template>
  <div class="correctness-header">
    <radio-button
      :correct="correct"
      :partial-credit="isPartialCredit"
      :answered="true"
      :selected="true"
      size="large"
    ></radio-button>
    <span class="label">{{ label }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { Flashcard } from '@/types/models';
import { useNextGenScoring } from '@/composables/useNextGenScoring';
import RadioButton from './RadioButton.vue';

const { correct, flashcard, answerIds = [], rawAnswerData } = defineProps<{
  correct: boolean;
  flashcard?: Flashcard;
  answerIds?: number[];
  rawAnswerData?: Record<string, unknown> | null;
}>();

const { nextGenScoringRule, correctnessLabel } = useNextGenScoring();

const label = computed(() => {
  if (flashcard && nextGenScoringRule(flashcard)) {
    return correctnessLabel(flashcard, answerIds, rawAnswerData);
  }
  return correct ? 'Correct' : 'Incorrect';
});

const isPartialCredit = computed(() => label.value === 'Partial Credit');
</script>

<style lang="scss" scoped>
.correctness-header {
  margin: 0;
  padding: 0;
  margin-top: rem-calc(8);
  margin-bottom: rem-calc(16);
  display: flex;
  align-items: center;
  gap: 0.5rem;

  span.label {
    font-size: rem-calc(30);
    font-weight: 600;
    line-height: rem-calc(32);
  }

  @include breakpoint(desktop) {
    margin-bottom: rem-calc(16);
    padding-left: 0;
  }
}
</style>
